import React, { useState } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';

export default function SetupForm({ setShowPaymentForm }) {
    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);
    const [paymentElementReady, setPaymentElementReady] = useState(false);

    const [errorMessage, setErrorMessage] = useState(null);

    const { REACT_APP_BASE_URL } = process.env;

    const handleSubmit = async event => {
        event.preventDefault();

        setLoading(true);
        if (!stripe || !elements) {
            return null;
        }

        const { error } = await stripe.confirmSetup({
            elements,
            confirmParams: {
                return_url: `${REACT_APP_BASE_URL}/supporting-information#payment`,
                payment_method_data: {
                    allow_redisplay: 'always'
                }
            }
        });

        if (error) {
            console.log('🚀 ~ SetupForm ~ error:', error);
            setLoading(false);
            setErrorMessage(error.message);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <PaymentElement onReady={() => setPaymentElementReady(true)} />
            {stripe && paymentElementReady && (
                <div className="d-flex gap-3 mt-3">
                    <button
                        className="btn btn-primary mt-3 d-flex align-items-center gap-2"
                        style={{ backgroundColor: '#3e9bd9', color: 'white', margin: '5px' }}
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? (
                            <span
                                className="spinner-border spinner-border-sm text-light"
                                role="status"
                                aria-hidden="true"
                            />
                        ) : (
                            'Submit'
                        )}
                    </button>
                    <button
                        className="btn btn-danger mt-3 d-flex align-items-center gap-2"
                        style={{ color: 'white', margin: '5px' }}
                        disabled={loading}
                        onClick={() => setShowPaymentForm(false)}
                    >
                        Cancel
                    </button>
                </div>
            )}
            {errorMessage && <div>{errorMessage}</div>}
        </form>
    );
}
